import { makeAutoObservable } from 'mobx';
import createStoreContext from '../createStoreContext';

export const [SuperAdminMemoryStoreProvider, useSuperAdminMemoryStore] =
  createStoreContext(
    class SuperAdminMemoryStore {
      targetUserId = '';
      targetOrganizationId = '';

      constructor() {
        makeAutoObservable(this);
      }

      setTargetUserId = (userId: string) => {
        this.targetUserId = userId;
      };

      setTargetOrganizationId = (organizationId: string) => {
        this.targetOrganizationId = organizationId;
      };
    },
  );

export type SuperAdminMemoryStore = ReturnType<typeof useSuperAdminMemoryStore>;
